// import Veggie from "../components/Veggie";
import Popular from "../components/Popular";
import { motion } from "framer-motion";
import Vegan from "../components/Vegan";
// import LowCarbs from "../components/LowCarbs";
import Whole30 from "../components/Whole30";
import styled from "styled-components";

function Home() {
  return (
    <motion.div
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card>
        <Whole30 />
        <Popular />
        <Vegan />
      </Card>
    </motion.div>
  );
}

const Card = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export default Home;
